Additional information that is accepted when posting a job ad to configure the features of this advertisement product.
